import React from 'react';
import {
  Box, Flex, Button, Heading, Text, Container,
  Menu, MenuButton, MenuList, MenuItem, IconButton, Drawer,
  DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton,
  useDisclosure, Icon
} from '@chakra-ui/react';
import { Link, useNavigate } from 'react-router-dom';
import { HamburgerIcon, ChevronDownIcon } from '@chakra-ui/icons';
import logoWithTag from '../assets/playmaker-logo-w-tag.png';

const Navigation = ({ isAuthenticated, userInfo, onLogout }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  
  return (
    <Box 
      as="nav" 
      bg="white" 
      boxShadow="sm" 
      position="sticky" 
      top={0} 
      zIndex={100}
      width="100%"
    >
      <Container maxW="container.xl" py={3}>
        <Flex justify="space-between" align="center">
          {/* Logo */}
          <Link to="/">
            <img src={logoWithTag} alt="PlayMaker Pics" height="40px" style={{ maxHeight: '40px' }} />
          </Link>
          
          {/* Desktop Navigation */}
          <Flex spacing={8} display={{ base: "none", md: "flex" }} alignItems="center">
            {isAuthenticated ? (
              <Menu>
                <MenuButton as={Button} rightIcon={<ChevronDownIcon />} variant="ghost" ml={4}>
                  {userInfo?.firstName || 'Account'}
                </MenuButton>
                <MenuList>
                  <MenuItem onClick={() => navigate('/dashboard')}>Dashboard</MenuItem>
                  <MenuItem onClick={onLogout}>Logout</MenuItem>
                </MenuList>
              </Menu>
            ) : (
              <Button 
                as={Link} 
                to="/login" 
                bg="#F6921E"
                color="white"
                _hover={{ bg: "#e58418" }}
              >
                Login
              </Button>
            )}
          </Flex>
          
          {/* Mobile Navigation Toggle */}
          <IconButton
            aria-label="Open menu"
            icon={<HamburgerIcon />}
            display={{ base: "flex", md: "none" }}
            variant="ghost"
            onClick={onOpen}
          />
        </Flex>
      </Container>
      
      {/* Mobile Navigation Drawer */}
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">Menu</DrawerHeader>
          <DrawerBody>
            <Flex direction="column" spacing={4} align="stretch" pt={4}>
              {isAuthenticated ? (
                <>
                  <Button as={Link} to="/dashboard" variant="ghost" my={2} onClick={onClose}>
                    Dashboard
                  </Button>
                  <Button variant="ghost" my={2} onClick={() => { onLogout(); onClose(); }}>
                    Logout
                  </Button>
                </>
              ) : (
                <Button 
                  as={Link} 
                  to="/login" 
                  bg="#F6921E"
                  color="white"
                  my={2}
                  onClick={onClose}
                >
                  Login
                </Button>
              )}
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default Navigation;